import React, {useEffect, useState} from 'react';
import RestorePrompt from './components/RestorePrompt.jsx';
import {pages} from './content/siteContent.js';
import ContentPage from './screens/ContentPage.jsx';
import MatchScreen from './screens/MatchScreen.jsx';
import SetupScreen from './screens/SetupScreen.jsx';
import {getCurrentPath, resolveInitialRoute} from './utils/path.js';
import {
  clearSession,
  loadSession
} from './utils/storage.js';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const NotFound = () => (
  <main className="min-h-[100dvh] bg-[#020617] px-6 text-white grid place-items-center">
    <div className="max-w-md text-center">
      <p className="text-sm font-black tracking-widest text-indigo-300">
        404
      </p>
      <h1 className="mt-2 text-3xl font-black">找不到這個頁面</h1>
      <p className="mt-4 leading-7 text-white/55">
        網址可能已變更或輸入錯誤。請返回首頁使用羽球計分板。
      </p>
      <a
        href="/"
        className="mt-6 inline-flex rounded-xl bg-indigo-500 px-5 py-3 font-black text-white"
      >
        返回首頁
      </a>
    </div>
  </main>
);

const App = () => {
  const initialRoute = resolveInitialRoute(getCurrentPath(), pages);
  const {page: contentPage, isHome, isNotFound} = initialRoute;
  const [match, setMatch] = useState(null);
  const [savedSession, setSavedSession] = useState(null);
  const [showRestore, setShowRestore] = useState(false);

  useEffect(() => {
    if (!isHome) return;

    const session = loadSession();
    if (
      session &&
      session.status === 'playing' &&
      session.scoreA + session.scoreB > 0
    ) {
      setSavedSession(session);
      setShowRestore(true);
    }
  }, [isHome]);

  if (contentPage) {
    return <ContentPage page={contentPage} />;
  }

  if (isNotFound) {
    return <NotFound />;
  }

  const handleRestore = () => {
    setShowRestore(false);
    setMatch({restored: true});
  };

  const handleDiscard = () => {
    clearSession();
    setSavedSession(null);
    setShowRestore(false);
  };

  const handleReset = () => {
    clearSession();
    setSavedSession(null);
    setMatch(null);
  };

  if (showRestore && savedSession) {
    return (
      <RestorePrompt
        session={savedSession}
        onRestore={handleRestore}
        onDiscard={handleDiscard}
      />
    );
  }

  if (!match) {
    return <SetupScreen onStart={setMatch} />;
  }

  return (
    <MatchScreen
      initMatch={match.restored ? null : match}
      savedState={
        match.restored
          ? {...savedSession, history: [], redoStack: []}
          : null
      }
      onReset={handleReset}
    />
  );
};

export default App;